<template>
  <section ref="richTextRef" class="rich-text content-block">
    <div class="container">
      <div class="row rich-text__row">
        <div class="col-lg-8 offset-lg-2">
          <sc-rich-text
            v-track-rich-text-links="'rich_text'"
            :field="fields.richText"
          ></sc-rich-text>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { RichTextFields, RichTextProps } from './types';
import { RichText as ScRichText } from '@sitecore-jss/sitecore-jss-vue';
import { onMounted, useTemplateRef } from 'vue';
import vTrackRichTextLinks from '../../directives/vTrackRichTextLinks';
import useRichTextTableTabindex from '../../utils/useRichTextTableTabindex';

withDefaults(defineProps<RichTextProps>(), {
  fields: () => ({}) as RichTextFields,
  params: () => ({}),
});

const richTextRef = useTemplateRef('richTextRef');

const { calculateTablesTabindex } = useRichTextTableTabindex(richTextRef);

onMounted(() => {
  calculateTablesTabindex();
});
</script>

<style lang="scss">
@import './scss/RichText.scss';
</style>
